module.exports = __webpack_public_path__ + "static/media/rounded-rect-white.938f1fbf.svg";